<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide8',
  data() {
    return {
      parallax: [
        {
          start: 5200,
          end: 5700,
          fromStyle: { transform: 'translateY(-1700px) rotateZ(-15deg)' },
          toStyle: { transform: 'translateY(150px) rotateZ(-15deg)' },
          easing: 'linear'
        },
        {
          start: 6900,
          end: 7400,
          fromStyle: { transform: 'translateY(150px) rotateZ(-15deg)' },
          toStyle: { transform: 'translateY(2000px) rotateZ(-15deg)' },
          easing: 'linear'
        }
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/08_Photo.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 450px;
    height: 500px;
    left: -265px;
    top: 32vh;
    transition: 0.6s;
    z-index: 3;
    @media(max-width: 600px) {
      width: 200px;
      left: -100px;
      top: calc(50% - 360px);
    }
}
</style>
